<!--
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-11-21 10:46:16
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2025-12-31 16:32:47
 * @FilePath: \betdoce-web\src\components\RewardDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <v-dialog :model-value="show" @click:outside="handleClose" max-width="320" transition="dialog-bottom-transition"
    @update:model-value="(val: any) => $emit('update:show', val)">
    <v-card class="activity-invite-modal">
      <v-card-title class="reward-title text-center">
        Bónus
      </v-card-title>
      <v-card-text class="reward-amount ">
        <img src="@/assets/images/h5/coin.png" alt="">
        <span> {{ (amount / 100).toFixed(2) }}</span>
      </v-card-text>
      <v-card-actions class="justify-center">
        <span class="reward-tip">Clique na tela para continuar</span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
const props = defineProps<{
  show: boolean,
  amount: number
}>();
const emit = defineEmits(['update:show', 'close']);
function handleClose() {
  emit('update:show', false);
  emit('close');
}
</script>

<style scoped lang="scss">
.activity-invite-modal {
  position: relative;
  background: #192A3B;
  border-radius: 8px 8px 8px 8px;
  overflow: hidden;
  padding: 0 15px;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 24px;

  .reward-title {
    // font-weight: 600;
    // font-size: 16px;
    // color: #FFFFFF;
    // line-height: 24px;
  }

  .v-card-text {
    background: #131C23;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
}

.reward-tip {
  font-weight: 600;
  font-size: 12px;
  color: #88929C;
  line-height: 18px;
}
</style>